import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetPreferredRelationshipsMutation } from '../apis';
import type { PreferredRelationsShipsQuerySchema } from '../schemas/preferred-relationships-query-schema';

export function PreferredRelationsShipsSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<PreferredRelationsShipsQuerySchema>) {
  const getName = useCallback(
    (item?: PreferredRelationsShipsQuerySchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink
          to="/settings/preferred-relationships/$id"
          params={{ id: `${item.id}` }}
          state={{ naturalBack: true }}
        >
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetPreferredRelationshipsMutation}
      disabled={disabled}
    />
  );
}
